import { StripePayment } from './StripePayment'
import { CUSTOM_COLORS } from '@/constants/theme'
import { type CommonPaymentInfo, PaymentMethodsType } from '@/view-models/payment'

export type TPGetPrimeParameter = Parameters<Parameters<typeof TPDirect.card.getPrime>[0]>[0]
export type TPLinePayGetPrimeParameter = Parameters<Parameters<typeof TPDirect.linePay.getPrime>[0]>[0]
export type TPAfteeGetPrimeParameter = Parameters<Parameters<typeof TPDirect.aftee.getPrime>[0]>[0]
export type TPCardUpdateCallback = Parameters<typeof TPDirect.card.onUpdate>[0]
export type TPCardUpdateParameter = Parameters<Parameters<typeof TPDirect.card.onUpdate>[0]>[0]

export const PaymentFactory = {
  async getPaymentFactory(payload: CommonPaymentInfo) {
    if (payload.pay_type === PaymentMethodsType.PromptPay) {
      await StripePayment.initialStripe(payload.info.publishable_key)
      return StripePayment.getInstance()
    }
    throw new Error('No payment factory found')
  },
}

export enum TapPayFieldStatus {
  /** 0 is successful */
  SUCCESS,
  /** 1 is empty */
  EMPTY,
  /** 2 is error */
  ERROR,
  /** 3 is typing */
  TYPING,
}

export const TapPaySDK = {
  init(fields: Parameters<typeof TPDirect.card.setup>[0]) {
    TPDirect.card.setup({
      // @ts-ignore
      fields,
      styles: {
        // Style all elements
        input: {
          color: CUSTOM_COLORS.black50,
        },
        // Styling ccv field
        'input.ccv': {
          'font-size': '16px',
        },
        // Styling expiration-date field
        'input.expiration-date': {
          'font-size': '16px',
        },
        // Styling card-number field
        'input.card-number': {
          'font-size': '16px',
        },
        // style focus state
        ':focus': {
          color: CUSTOM_COLORS.black50,
        },
        // style valid state
        '.valid': {
          color: CUSTOM_COLORS.black50,
        },
        // style invalid state
        '.invalid': {
          color: CUSTOM_COLORS.red50,
        },
        '::placeholder': {
          color: CUSTOM_COLORS.gray50,
        },
      },
      // 此設定會顯示卡號輸入正確後，會顯示前六後四碼信用卡卡號
      isMaskCreditCardNumber: true,
      maskCreditCardNumberRange: {
        beginIndex: 6,
        endIndex: 11,
      },
    })
  },
  getPrime() {
    return new Promise<TPGetPrimeParameter>((resolve, reject) => {
      if (!TPDirect.card.getTappayFieldsStatus().canGetPrime) {
        reject(new Error('can not get prime'))
      }
      TPDirect.card.getPrime(result => {
        if (result.status !== 0) {
          reject(result)
        }
        resolve(result)
      })
    })
  },
  getLinePayPrime() {
    return new Promise<TPLinePayGetPrimeParameter>((resolve, reject) => {
      TPDirect.linePay.getPrime(result => {
        if (result.status !== 0) {
          reject(result)
        }
        resolve(result)
      })
    })
  },
  getAfteePrime() {
    return new Promise<TPAfteeGetPrimeParameter>((resolve, reject) => {
      TPDirect.aftee.getPrime(result => {
        if (result.status !== 0) {
          reject(result)
        }
        resolve(result)
      })
    })
  },
  onCardUpdate(cb: TPCardUpdateCallback) {
    TPDirect.card.onUpdate(cb)
  },
}
